import * as React from "react";
import GameMode from "./GameMode";
import GameStatisticsButton from "./GameStatisticsButton";
import SettingsButton from "./SettingsButton";
var Header = function (props) { return (React.createElement("div", { className: "mb-4" },
    React.createElement("div", { className: "flex flex-wrap items-center justify-between gap-2" },
        React.createElement("h1", { className: "m-0 text-lg font-bold tracking-tight text-[var(--text-on-felt)] sm:text-xl" },
            React.createElement(GameMode, { gameMode: props.gameMode })),
        React.createElement("div", { className: "flex items-center gap-1 text-[var(--text-on-felt)]" },
            React.createElement(SettingsButton, null),
            React.createElement(GameStatisticsButton, null))),
    props.chatLink !== undefined && props.chatLink !== null ? (React.createElement("p", { className: "mt-1 text-sm text-[var(--text-on-felt-soft)]" },
        "Join the chat at",
        " ",
        React.createElement("a", { href: props.chatLink, target: "_blank", rel: "noreferrer", className: "text-[var(--accent)] underline" }, props.chatLink))) : null)); };
export default Header;
